import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export type PatchVehicleSearchEventPayload = {
  vehicleSearchEventId: string;
  lastSearchCriteria?: string;
  lastSearchVehicleCount?: number;
  searchResultsViewed?: boolean;
};

export const patchVehicleSearchEvent = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (payload: PatchVehicleSearchEventPayload): Promise<string> => {
      return fetchWithAuth<string>(
        "patchDossierVehicleSearchEvent",
        dossierId,
        {
          requestOptions: {
            method: "PATCH",
            body: JSON.stringify(payload),
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
